import { SERVER_URL } from '../constants';
import { IPayError, IPaySuccess } from '../types';

export const decryptPaymentDataApi = async (props: {
  type: 'ApplePay' | 'GooglePay',
  publicKey: string,
  keyId: string,
  googlePaymentData?: google.payments.api.PaymentData['paymentMethodData'],
  applePaymentData?: ApplePayPaymentToken,
  includeBIN: boolean,
}): Promise<IPaySuccess | IPayError> => {
  const res = await fetch(`${SERVER_URL}/PayPage/DecryptPaymentData`, {
    method: 'POST',
    body: JSON.stringify(props),
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
    },
  });
  
  const result = await res.json();

  if (res.status !== 200) {
    throw new Error(result?.title || 'Decryption Error Happened');
  }

  return result;
};

export const decryptGooglePayData = async (props: {
  publicKey: string,
  keyId: string,
  googlePaymentData: google.payments.api.PaymentData['paymentMethodData'],
  includeBIN: boolean,
}): Promise<IPaySuccess | IPayError> => {
  return decryptPaymentDataApi({ type: 'GooglePay', ...props });
};

export const decryptApplePayData = async (props: {
  publicKey: string,
  keyId: string,
  applePaymentData: ApplePayPaymentToken,
  includeBIN: boolean,
}): Promise<IPaySuccess | IPayError> => {
  return decryptPaymentDataApi({ type: 'ApplePay', ...props });
};
